import { OrderFromCart, Coupon } from 'src/app/interfaces';

export class AddToCart {
    static readonly type = '[Cart] add to cart';
    constructor(public payload: string) {}
}
export class RemoveFromCart {
    static readonly type = '[Cart] remove from cart';
    constructor(public payload: string) {}
}

export class GetCart {
    static readonly type = '[Cart] get cart';
}

export class ShipmentMethods {
    static readonly type = '[Cart] get shipment options';
}

export class UpdateCartOrder {
    static readonly type = '[Cart] update cart order';
    constructor(public payload: OrderFromCart) {}
}

export class CreateCartOrder {
    static readonly type = '[Cart] generate cart order';
}

export class GetCartOrderState {
    static readonly type = '[Cart] get cart order status';
}

export class AddCouponToCart {
    static readonly type = '[Cart] add coupon to cart';
    constructor(public payload: Coupon) {}
}

export class RemoveCouponToCart {
    static readonly type = '[Cart] remove coupon to cart';
    constructor(public payload: Coupon) {}
}
